import { inject, Injectable } from '@angular/core';
import { AlertService } from '@core/services/alert.service';
import {
  API_ERROR_FALLBACKS,
  ApiErrorFallbackKey,
  ApiSuccessMessageKey,
} from '@core/constants/messages/api-messages.constants';
import { getApiErrorMessage, getApiSuccessMessage } from '@shared/utils/api-response.utils';

@Injectable({
  providedIn: 'root',
})
export class ApiMessageService {
  private readonly alertService = inject(AlertService);

  success(key: ApiSuccessMessageKey, params?: Record<string, string | number>): void {
    this.alertService.success(getApiSuccessMessage(key, params));
  }

  error(source: unknown, fallbackKey: ApiErrorFallbackKey = 'GENERIC'): void {
    this.alertService.error(getApiErrorMessage(source, API_ERROR_FALLBACKS[fallbackKey]));
  }
}
